<common-top-tool-bar [title]="pageTitle"
                     [back]="'/admin/v3/resource/'+bisType+'/edit/'+book_id"
                     [query]="{tabIndex: 1}"
                     [actionsTemplate]="actions">
  <ng-template #actions>
    <button nz-button [nzType]="'primary'" class="mr-4"
            [nzSize]="'large'" nzGhost
            [routerLink]="'/admin/v3/resource/'+bisType+'/courseware'">
      取消
    </button>
    <button nz-button [nzType]="'primary'"
            [nzSize]="'large'"
            (click)="save($event)">
      {{this.book_id ? '儲存' : '確定新增' }}
    </button>
  </ng-template>
</common-top-tool-bar>


<!--<input nz-input [(ngModel)]="quizzes_relate" placeholder="large size" nzSize="large" />-->



<ng-template #modalContent>
  <nz-spin [nzSpinning]="false">
<!--    <app-admin-book-resource-courseware-list-->
<!--      [resourceType]="'audio'"-->
<!--      [(itemSelection)]="itemSelection"></app-admin-book-resource-courseware-list>-->
    <app-admin-book-resource-courseware-list
      [single]="true"
      [(itemSelection)]="quizSelection"
      [resourceType]="'exercise'">
    </app-admin-book-resource-courseware-list>
  </nz-spin>
</ng-template>
<ng-template #modalFooter>
  <div>
    <button nz-button class="mr-4" nzType="primary" [nzSize]="'default'"
            (click)="showQuizSelectDialog=false" nzGhost>
      关闭
    </button>
  </div>
</ng-template>
<nz-modal
  [nzWidth]="'80%'"
  nzWrapClassName="v3"
  [nzKeyboard]="false"
  [nzMaskClosable]="false"
  [nzClosable]="false"
  [(nzVisible)]="showQuizSelectDialog"
  [nzContent]="modalContent"
  [nzTitle]="null"
  [nzFooter]="modalFooter"
  (nzOnCancel)="closeQuizSelectDialog()"
>


</nz-modal>





<div class="quiz-list" style="padding: 1.5rem 0rem;">
  <ng-container *ngIf="!quizzes_relate.length">
    <button nz-button [nzType]="'primary'"
            [nzSize]="'large'"
            (click)="showQuizSelectDialog = true">
      添加关联题包
    </button>
  </ng-container>
  <div *ngFor="let quiz of quizzes_relate; let i = index" class="quiz-card">
    <div class="quiz-header">
      <span class="quiz-number">题包 {{ i + 1 }} : {{quiz.name}}</span>
      <div class="quiz-actions">
        <a [routerLink]="['/admin/v3/resource/exercise/edit/'+quiz.id+'/index']" [queryParams]="{ tabIndex: 1 }" target="_blank">edit</a>
        <nz-divider nzType="vertical"></nz-divider>
        <a class="danger-link" (click)="deleteQuiz(quiz)">delete</a>
      </div>
    </div>
    <!--
    <div class="quiz-body">
      <div class="quiz-question">{{ quiz.question }}</div>
      <div class="quiz-options">
        <div
          *ngFor="let option of quiz.options; let j = index"
          class="quiz-option"
          [class.correct-answer]="isCorrectAnswer(quiz, j)">
          <span class="option-label">{{ getOptionLabel(j) }}</span>
          <span class="option-text">{{ option }}</span>
          <i *ngIf="isCorrectAnswer(quiz, j)" nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a" class="option-check"></i>
        </div>
      </div>
    </div>
    -->
  </div>
</div>
